import React, { type FunctionComponent, useMemo } from 'react'
import { Text } from '@retailer-platform/shared-components'
import { type PartnerPickDeviceDatum } from 'domains/partner-pick-devices/types/partnerPickDevices.types'
import { DeviceTypeEnum } from 'domains/partner-pick-devices/api'

interface Props {
  partnerPickDevice: PartnerPickDeviceDatum
}

export const PartnerPickDevicesListLoginCell: FunctionComponent<Props> = ({
  partnerPickDevice: { deviceType, phone },
}) => {
  const formattedLogin = useMemo(() => {
    const regex = /(\d{3})(\d{3})(\d{4,})/i
    const match = phone.match(regex)
    if (match) {
      if (deviceType === DeviceTypeEnum.Wifi) {
        return `${match[1]} ${match[2]} ${match[3]}` // xxx xxx xxxx
      }

      return `(${match[1]}) ${match[2]}-${match[3]}` // (xxx) xxx-xxxx
    }

    return phone
  }, [deviceType, phone])

  return <Text>{formattedLogin}</Text>
}
